import React from 'react';
import classnames from 'classnames';
import { TabProps, Tab, TabLink } from './Tab';
import GlobalProps from '../globalProps';
import './Tabs.css';
import { Container } from '../Container/Container';

interface Props extends GlobalProps {
  tabGroups: TabProps[][];
  accessory?: React.ReactNode;
  useNavigation?: boolean;
  inline?: boolean;
  displayAsPills?: boolean;
}

export function Tabs({
  tabGroups,
  accessory,
  className,
  style,
  useNavigation = true,
  inline,
  displayAsPills,
}: Props): JSX.Element {
  return (
    <div
      className={classnames('tabs', { 'tabs--inline': inline, 'tabs--pills': displayAsPills }, className)}
      style={style}
    >
      <Container>
        <div className="tabs__container">
          {tabGroups.map((group, index) => (
            <div className="tabs__group" key={index}>
              {group.map((e) => {
                if (useNavigation) {
                  return <TabLink key={e.title} {...e} />;
                }
                return <Tab key={e.title} {...e} />;
              })}
            </div>
          ))}
        </div>
        {accessory}
      </Container>
    </div>
  );
}
